import { render, staticRenderFns } from "./BtnColorNeo.vue?vue&type=template&id=420617d0&"
import script from "./BtnColorNeo.vue?vue&type=script&lang=js&"
export * from "./BtnColorNeo.vue?vue&type=script&lang=js&"
import style0 from "./BtnColorNeo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VColorPicker,VMenu})
